import React from "react";
import { put, putWithToken, patchWithToken } from "$ACTIONS/TlcRequest";
import { Spin, Steps } from "antd";
import { pwdReg, emailReg } from "$ACTIONS/reg";
import { ApiPort, APISETS } from "$ACTIONS/TLCAPI";
import { Button, message, Input, Form, Modal, Tabs } from "antd";
import {
    PasswordIcon,
    EmailIcon,
} from "@/UserSign/RegisterIcnoSvg";
import { getQueryVariable } from "$ACTIONS/helper";
const { Step } = Steps;
const TabPane = Tabs.TabPane;
message.config({
    top: 100,
    duration: 2,
    maxCount: 1,
});

// copy from Register.js
const regSymbols = /[\s]/;
class ResetPwd extends React.Component {
    constructor(props) {
        super(props);
        this.showEmailStep = 0;
        this.showPwdStep = 1;
        this.state = {
            uiEmailNameState: '',
            isEmailInputFocused: false,
            didEmailInputed: false,
            EmailAccount: "",
            emailSuggestions: [], // 推薦郵箱

            uiNewPwd:'',
            didNewPwdInputed: false,
            uiConfirmPwd:'',
            didConfirmPwdInputed: false,

            curStep: 0,
            loadingReset: false,
            NEWPWD: "",
            OLDPWD: "",
            visible: false,
            Name: "",
            Email: "",
            EmailForForgetUser: "",
            loading: false,
            defaultkey: "1",
            activeIndex: "1",
            errorname: "",
            erroremail: "",
            erroremailForForgetUser: "",
            errorMessage: "",
            errorMessageForForgetUser: "",
            submitstatus: false,
            invalidEmailInput: true,
            invalidInput: true,
            invalidInputForForgetUser: true,
        };
        this.UpdateMemberPWD = this.UpdateMemberPWD.bind(this);
        this.MemberChange = this.MemberChange.bind(this);
        this.EmailForgetPassword = this.EmailForgetPassword.bind(this);
        this.Forgetuser = this.Forgetuser.bind(this);
    }
    componentDidMount() {
        this.setState({
            defaultkey: this.props.Forgotkey,
        });

        const actionParam = getQueryVariable("action");
        actionParam === "forget" && this.showModal(1);
    }

    // copy from Register.js START
    handleEmailChange = (e) => {
		const value = e.target.value;
		const atIndex = value.indexOf('@');

		// 如果用戶輸入了 "@"
		if (atIndex !== -1) {
			const namePart = value.slice(0, atIndex); // 獲取 "@"之前的部分
			const domainPart = value.slice(atIndex + 1);
			const emailSuffixes = [
				"qq.com",
				"163.com",
				"sina.com",
				"sohu.com",
				"126.com",
				"139.com",
				"wo.cn",
				"hotmail.com",
				"msn.com",
				"outlook.com"
			];

			// 將namePart和推薦的網域部分結合起來
			const suggestions = emailSuffixes.filter(suffix => suffix.startsWith(domainPart))
											.map(suffix => `${namePart}@${suffix}`);

			this.setState({ EmailAccount: value, emailSuggestions: suggestions });
		} else {
			this.setState({ EmailAccount: value, emailSuggestions: [] });
		}
	}

    /**
	 * @description: 處理點擊建議
	 * @param {*}
	 * @return {void}
    */
	handleSuggestionClick = (suggestion, e) => {
        this.setState({ EmailAccount: suggestion, emailSuggestions: [] });

		//要改this.props.form.setFieldsValue({ emailNameState: suggestion });
        this.emailNameState = suggestion;
        this.setState({uiEmailNameState:suggestion});

		//手動觸發表單驗證
		//要改 this.props.form.validateFields(['emailNameState']);
	}
    // copy from Register.js END

    onChange(event, type) {
        const val = event.target.value;
        //
        if ('emailNameState'===type) {
            this.setState({uiEmailNameState:val, didEmailInputed:true});
        } else if ('newPwd'===type) {
            this.setState({uiNewPwd:val, didNewPwdInputed:true})
        } else if ('confirmPwd'===type) {
            this.setState({uiConfirmPwd:val, didConfirmPwdInputed:true})
        }
        // control button disabled or not
        this[type] = val;
        this.setState({invalidInput:!(this.confirmPwd && this.newPwd && this.confirmPwd==this.newPwd)})
        this.setState({invalidEmailInput:!this.emailNameState})
    }

    MemberChange(type, e) {
    }

    showModal = (e, conf={}) => {
        this.showModalConf = conf||{};
        this.setState({
            curStep: conf.curStep,
            visible: true,
            defaultkey: e,
        });
    };

    handleCancel = (e) => {
        this.setState({
            visible: true,
        });
        //	this.props.pwdModalClose('isShowPwdModal', false);
    };

    EmailForgetPassword() {
    }

    Forgetuser() {
    }
    UpdateMemberPWD() {
    }

    render() {
        const {
            loading,
            defaultkey,
            activeIndex,
            visible,
            Name,
            Email,
            EmailForForgetUser,
            errorname,
            erroremail,
            erroremailForForgetUser,
            submitstatus,
        } = this.state;
        return (
            <Modal
                title={this.state.curStep==this.showEmailStep ? "添加邮箱" : "更换密码"}
                visible={visible}
                onOk={this.handleCancel}
                onCancel={this.handleCancel}
                destroyOnClose={true}
                footer={null}
                className="modal-pubilc ForgotPwdModal hide-ant-modal-close-x-modal"
                width={400}
                zIndex={2000}
            >
                <Spin spinning={this.state.loadingReset} tip="请稍后...">
                    <div style={{display:this.state.curStep==this.showEmailStep?'':'none'}}>
                        <div className="StepsBox" style={{margin:'0 0 0 22px'}}>
                            <Steps current={0} size="small">
                                <Step />
                                <Step />
                            </Steps>
                        </div>
                        <div className="IputBox">
                            <div>
                                <label style={{float:'left'}}>邮箱</label>
                                <Input
                                    value={this.state.uiEmailNameState}
                                    type="text"
                                    size="large"
                                    maxLength={"50"}
                                    placeholder="请输入电子邮箱"
                                    onChange={(e) => this.onChange(e, "emailNameState")+this.handleEmailChange(e)}
                                    onFocus={() => this.setState({ isEmailInputFocused: true })}
                                    onBlur={() => this.setState({ isEmailInputFocused: false })}
                                    // onPressEnter={() => this.HandleEnterKey()}
                                />
                                {/* {(submitstatus || erroremail) &&
                                    (Email === "" ||
                                        !emailRegex.test(Email)) && (
                                        <div className="error">
                                            {erroremail}
                                        </div>
                                    )} */}
                                {this.state.didEmailInputed && !this.state.uiEmailNameState && <div className="resetPwdindexjs"><div className="input-error-message">请输入电子邮箱</div></div>}
                                {this.state.uiEmailNameState && !emailReg.test(this.state.uiEmailNameState) && <div className="resetPwdindexjs"><div className="input-error-message">请输入有效的电子邮箱</div></div>}
                                {this.state.emailSuggestions && this.state.isEmailInputFocused &&
                                    <ul className="email-suggestions">
                                        {this.state.emailSuggestions.map((suggestion, index) => (
                                            <li key={index}
                                                className="email-suggestion"
                                                onMouseDown={(e) => this.handleSuggestionClick(suggestion,e)}
                                            >
                                                {suggestion}
                                            </li>
                                        ))}
                                    </ul>
                                }
                            </div>
                        </div>
                        <Button
                            disabled={this.state.invalidEmailInput}
                            type="primary"
                            size="large"
                            onClick={() => {
                                const { emailNameState } = this;

                                if (!emailReg.test(emailNameState)) {
                                    message.error("请输入正确的邮箱");
                                    return;
                                }

                                this.setState({ loadingReset: true });
                                patchWithToken(ApiPort.PATCHMemberlistAPI, {
                                    key: "Email",
                                    value1: emailNameState,
                                }, this.showModalConf.memberToken)
                                    .then((res) => {
                                        this.setState({ loadingReset: false });
                                        if (res && res.isSuccess && res.result?.code==='MEM00075') {
                                            message.success("更新邮箱成功！");
                                            this.setState({curStep:this.showPwdStep})
                                        } else {
                                            message.error("更新邮箱失败！");
                                        }
                                    });
                            }}
                            // loading={loading}
                            style={{ width: "100%" }}
                        >
                            提交
                        </Button>
                    </div>
                    <div style={{display:this.state.curStep==this.showPwdStep?'':'none'}}>
                        <div className="StepsBox" style={{margin:'0 0 0 22px'}}>
                            <Steps current={1} size="small">
                                <Step />
                                <Step />
                            </Steps>
                        </div>
                        <div className="IputBox">
                            <div>
                                <label style={{float:'left'}}>新密码</label>
                                <Input.Password
                                    value={this.state.uiNewPwd}
                                    type="password"
                                    size="large"
                                    placeholder="请输入 6 - 20 位密码"
                                    onChange={(e) => this.onChange(e, "newPwd")}
                                    maxLength={16}
                                />
                                {this.state.didNewPwdInputed && !this.state.uiNewPwd && <div className="resetPwdindexjs"><div className="input-error-message">请输入新密码</div></div>}
                                {this.state.uiNewPwd && !pwdReg.test(this.state.uiNewPwd) && <div className="resetPwdindexjs"><div className="input-error-message">密码必须包含6-16个字符，必须同时包含字母和数字（可以包含^#$@中的特殊字符）</div></div>}
                            </div>
                            <div style={{height:10}}></div>
                            <div>
                            <label style={{float:'left'}}>确认新密码</label>
                            <Input.Password
                                value={this.state.uiConfirmPwd}
                                type="password"
                                size="large"
                                placeholder="再次输入密码确认"
                                onChange={(e) => this.onChange(e, "confirmPwd")}
                                maxLength={16}
                            />
                                {this.state.didConfirmPwdInputed && !this.state.uiConfirmPwd && <div className="resetPwdindexjs"><div className="input-error-message">请输入确认新密码</div></div>}
                                {this.state.uiConfirmPwd && !pwdReg.test(this.state.uiConfirmPwd) && <div className="resetPwdindexjs"><div className="input-error-message">密码必须包含6-16个字符，必须同时包含字母和数字（可以包含^#$@中的特殊字符）</div></div>}
                                {this.state.uiConfirmPwd && pwdReg.test(this.state.uiConfirmPwd) && this.state.uiNewPwd!=this.state.uiConfirmPwd && <div className="resetPwdindexjs"><div className="input-error-message">"新密码" 与 "确认新密码" 需相同</div></div>}
                            </div>
                        </div>
                        <Button
                            disabled={this.state.invalidInput}
                            type="primary"
                            size="large"
                            onClick={() => {
                                const { newPwd, confirmPwd } = this;

                                if (pwdReg.test(newPwd) === false) {
                                    message.error("请输入正确新密码。");
                                    return;
                                }

                                if (pwdReg.test(confirmPwd) === false) {
                                    message.error("请输入正确确认密码。");
                                    return;
                                }

                                if (newPwd !== confirmPwd) {
                                    message.error("密码输入不一致。");
                                    return;
                                }

                                const MemberData = {
                                        newPassword: newPwd,
                                    };
                                this.setState({ loadingReset: true });
                                putWithToken(ApiPort.SetChangePassword, MemberData, this.showModalConf.memberToken)
                                    .then((res) => {
                                        this.setState({ loadingReset: false });
                                        if (res && res.isSuccess) {
                                            /*
                                            Modal.info({
                                                title: "成功",
                                                okText: "关闭",
                                                content:
                                                    "恭喜你已成功重置您的密码，请您使用新密码登入。",
                                            });
                                            */
                                            this.setState({ visible: false, curStep:0 }, ()=>{
                                                this.newPwd='';
                                                this.confirmPwd=''
                                            });
                                            message.success("恭喜你已成功重置您的密码，请您使用新密码登入。");
                                            Array.from(document.querySelectorAll('.login-wrap input')).forEach($e=>{$e.value='';})
                                        } else {
                                            message.error("重置密码失败！");
                                            /*
                                            Modal.info({
                                                title: "失败",
                                                okText: "关闭",
                                                content: "重置密码失败！",
                                            });
                                            */
                                        }
                                    })
                                    .catch((error) => {
                                        console.log(error);
                                    });
                            }}
                            // loading={loading}
                            style={{ width: "100%" }}
                        >
                            提交
                        </Button>
                    </div>
                </Spin>
            </Modal>
        );
    }
}
export default ResetPwd;